"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DUMP_SESSION_KEYS = exports.NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG = exports.NOISE_MSG_MAX_LENGTH_BYTES = void 0;
exports.NOISE_MSG_MAX_LENGTH_BYTES = 65535;
exports.NOISE_MSG_MAX_LENGTH_BYTES_WITHOUT_TAG = exports.NOISE_MSG_MAX_LENGTH_BYTES - 16;
exports.DUMP_SESSION_KEYS = process.env.DUMP_SESSION_KEYS;
//# sourceMappingURL=constants.js.map